<template>
  <div id="compreSportsMeet_schedule" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        v-if="selectOptData"
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
        :manualRefresh="selectOpt_manualRefresh"
      ></marathon_select_opt>
    </div>
    <template v-if="themeItem && matchList && matchList.length > 0">
      <multipleChoiceShare_fixedBtn
        :model="multipleChoiceShareFixedBtn_model"
        :state="multipleChoiceShareFixedBtn_state"
        :modeType="multipleChoiceShareFixedBtn_modeType"
        :smallBtnArr="smallBtnArr"
        @changeModelEvent="changeModelEventHandler"
        @clickSmallBtnEvent="clickSmallBtnEventHandler"
        @clickFixedBtnEvent="clickFixedBtnEventHandler"
        :isShow="!noData"
      ></multipleChoiceShare_fixedBtn>
    </template>
    <div
      class="teamTable"
      :class="
        multipleChoiceShareFixedBtn_model === 'circular'
          ? 'multipleChoiceShare_fixedBtn_isCircular'
          : ''
      "
    >
      <div class="tableScrollArea" ref="tableParentDom">
        <div class="match_label_fixed" v-show="curMatchLabelFixedIcon">
          <div class="match_label">
            <span class="label_textArea">
              <span class="labelIcon">
                <img
                  :src="
                    currSid === 'ASG2026'
                      ? `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/ASG2026/${currBigSports.icon}.png`
                      : `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/sportsIcon/${currBigSports.icon}.png`
                  "
                />
              </span>
              <span
                :class="[
                  currBigSports.label && currBigSports.label.length === 2
                    ? 'letterSpa'
                    : '',
                ]"
                v-text="currBigSports.label"
              ></span>
            </span>
          </div>
        </div>
        <div :class="scrollDomClassName">
          <schedule_group_matchList
            v-for="item in matchList"
            :currCid="currCid"
            :currSid="currSid"
            :key="item.icon"
            :currThemeObj="currThemeObj"
            :data="item"
            :pbPx="matchItemPbpx"
            :matchListType="'player'"
          >
            <template v-slot:matchList>
              <schedulePlayers_match_list
                :currCid="currCid"
                :currSid="currSid"
                :currThemeObj="currThemeObj"
                :data="item.list"
                :detailPathName="''"
                :chooseState="multipleChoiceShareFixedBtn_state"
                :localStorageName="
                  multipleChoiceShareFixedBtn_modeType &&
                  multipleChoiceShareFixedBtn_modeType.localStorageName
                    ? multipleChoiceShareFixedBtn_modeType.localStorageName
                    : ''
                "
                @changeChooseNumEvent="changeChooseNumEventHandler"
                @clickMatchItemRadioItemEvent="
                  clickMatchItemRadioItemEventHandler
                "
                @clickMatchItemCheckboxItemEvent="
                  clickMatchItemCheckboxItemEventHandler
                "
                :channelType="currScheduleMatchList_channelType"
              />
            </template>
          </schedule_group_matchList>
        </div>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
    <complex_multipleChoiceShare_dialog
      v-if="dialogItem && dialogItem.isDialogFlag"
      :currThemeObj="currThemeObj"
      :axiosBaseUrl="axiosBaseUrl"
      :platfromMenu_currGroup="currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :dialogItem="dialogItem"
      :themeItem="themeItem"
      :localStorageChooseList="localStorageChooseList"
      :multipleChoiceShareFixedBtn_modeType="
        multipleChoiceShareFixedBtn_modeType
      "
      :curTimeZoneItem="curTimeZoneItem"
      @dialogCancelEvent="clickSmallBtnEventHandler"
      @dialogOkEvent="dialogOkEventHandler"
      @shareDoneEvent="shareDoneEventHandler"
      :commitBeforeCheckoutCallback="
        multipleChoiceShare_commitBeforeCheckoutCallback
      "
    >
      <template v-slot:checkList>
        <schedulePlayers_match_list
          :currCid="currCid"
          :currSid="currSid"
          :currThemeObj="currThemeObj"
          :data="localStorageChooseList"
          :detailPathName="''"
          :chooseState="multipleChoiceShareFixedBtn_state"
          :localStorageName="
            multipleChoiceShareFixedBtn_modeType &&
            multipleChoiceShareFixedBtn_modeType.localStorageName
              ? multipleChoiceShareFixedBtn_modeType.localStorageName
              : ''
          "
          @changeChooseNumEvent="changeChooseNumEventHandler"
          @clickMatchItemCheckboxItemEvent="
            clickMatchItemCheckboxItemEventHandler
          "
          :channelType="currScheduleMatchList_channelType"
        />
      </template>
    </complex_multipleChoiceShare_dialog>
  </div>
</template>

<script>
import {
  https_playersSchedule_matchList,
  https_sportsList,
  https_select_dateBigSports,
  https_select_delegationList,
} from '@api/platfrom_compreSportsMeet_api'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'

import schedule_group_matchList from '@components/platfromBase/compreSportsMeet/schedule_group_matchList.vue'
import schedulePlayers_match_list from '@components/platfromBase/compreSportsMeet/schedulePlayers_match_list.vue'
import multipleChoiceShare_fixedBtn from '@components/platfromBase/compreSportsMeet/multipleChoiceShare_fixedBtn.vue'
import complex_multipleChoiceShare_dialog from '@components/platfromBase/compreSportsMeet/complex_multipleChoiceShare_dialog.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import multipleChoiceShare_data_mixin from '@mixins/multipleChoiceShare_data'

export default {
  name: 'compreSportsMeet_schedule',
  components: {
    marathon_select_opt,
    schedule_group_matchList,
    BackTop,
    multipleChoiceShare_fixedBtn,
    complex_multipleChoiceShare_dialog,
    schedulePlayers_match_list,
  },
  mixins: [cup_base_data_mixin, multipleChoiceShare_data_mixin],
  props: {
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    bigSportsList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      isScrollBottom: false,
      firstPageIsScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      loading: false,
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      matchLabelArr: [],
      matchList: null,
      matchTotal: 0,
      currStageMatchDate: '',
      currStageBigSports: '',
      currStageDelegation: '',
      selectAllObj: {
        value: 'all',
        name: '全部',
      },
      matchDateArr: [],
      bigSportsArr: [],
      delegationArr: [],
      selectOptData_origin: {
        configArr: [
          {
            type: 'matchDate',
            title: '日期',
            origin_keyVal: ['value', 'name'],
            dataName: 'matchDateArr',
            selectIndex: 0,
          },
          {
            type: 'bigSports',
            title: '项目',
            origin_keyVal: ['value', 'name'],
            dataName: 'bigSportsArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'delegation',
            title: '代表团',
            origin_keyVal: ['value', 'name'],
            dataName: 'delegationArr',
            selectIndex: 1,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      selectOptData: null,
      showBackTop: false,
      multipleChoiceShareFixedBtn_modeType: {
        btnName: '今日出场名单',
        localStorageName: 'mixtmt_choose_eventPlayersCSMeet',
        unit: '场',
        customkeyArrActJson: {
          sportsId: {
            type: 'Array', //放到json里面字段值类型是数组
            isOnly: false, //是否去重
            keyArr: ['disciplineCodes', 'sportsId'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
          },
          actChannelArr: {
            type: 'Array', //放到json里面字段值类型是数组
            isOnly: false, //是否去重
            keyArr: ['competitorCodes', 'actChannelArr'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
          },
          scheduleArr: {
            type: 'Array', //放到json里面字段值类型是数组
            isOnly: false, //是否去重
            keyArr: ['scheduleCodes', 'scheduleArr'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
          },
          channelTvs: {
            type: 'Array', //放到json里面字段值类型是数组
            isOnly: false, //是否去重
            keyArr: ['channels', 'channelTvs'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
          },
          startDate: {
            type: 'Array', //放到json里面字段值类型是字符串
            isThisObj: false, //是否是this中的对象，true为是；flase为不是
            keyArr: ['startDates', 'startDate'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
          },
        },
      },
      themeTemplateType: 19,
      currScheduleMatchList_channelType: 'checkbox',
    }
  },
  created() {
    this.initPbPx()
    if (this.currGroup) {
      this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    currBigSports() {
      let label = ''
      this.bigSportsList.forEach((item) => {
        if (item.id === this.curMatchLabelFixedIcon) {
          label = item.CN
        }
      })
      return {
        label: label,
        icon: this.curMatchLabelFixedIcon,
      }
    },
    // curMatchListNum() {
    //   let curMatchListNum = 0
    //   if (this.matchList && this.matchList.length > 0) {
    //     this.matchList.forEach((group) => {
    //       curMatchListNum +=
    //         group.list && group.list.length ? group.list.length : 0
    //     })
    //   } else {
    //     curMatchListNum = -1
    //   }
    //   console.debug('curMatchListNum:', curMatchListNum)
    //   return curMatchListNum
    // },
    noMore() {
      console.debug('noMore:', this.matchTotal, this.isScrollBottom)
      return this.matchTotal !== 0
    },
    noData() {
      return (
        this.matchTotal === 0 && this.matchList && this.matchList.length === 0
      )
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.selectOptData = JSON.parse(JSON.stringify(this.selectOptData_origin))
      this.initMatchListQuery()
      console.debug(this.currCid, this.currSid)
      if (this.initFindanalysisItem && (!this.themeItem || !this.crossSeason)) {
        this.initFindanalysisItem()
      }
      await this.getBigSportsList()
      await this.getStageDateSports()
      await this.getDelegationList()
      await this.getScheduleMatchList()
      if (this.matchDateArr.length > 0) {
        this.computedSelectOpt(this.selectOptData.configArr)
      }

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async selectOpt_manualRefresh() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getScheduleMatchList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom,
      //   this.matchTotal
      // )
      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }
      // if (scrollTop > 0) {
      //   this.changeMatchLabelFixed(scrollTop, direction)
      // }

      this.scrollChangeHandler(scrollTop)

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
          // this.load()
          if (this.pnum > this.allPages) {
            this.isScrollBottom = true
          }
        }
      } else {
        // 滚动到顶部
        this.isScrollBottom = false
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }
      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      console.debug(
        'this.parentWidthPx:',
        this.$refs.tableParentDom.scrollHeight
      )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]
      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      // console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    multipleChoiceShare_commitBeforeCheckoutCallback(
      multipleChoiceShareFixedBtn_modeType
    ) {
      console.debug(
        'multipleChoiceShareFixedBtn_modeType:',
        multipleChoiceShareFixedBtn_modeType
      )
      let isCheckoutFlag = true
      let errorTipText = ''
      let chooseObj = this.getLocalStorageChooseObj(
        multipleChoiceShareFixedBtn_modeType.localStorageName
      )
      if (
        multipleChoiceShareFixedBtn_modeType.localStorageName ===
        'mixtmt_choose_eventPlayersCSMeet'
      ) {
        // 选择竞赛者需要验证
        for (let i = 0; i < this.matchList.length; i++) {
          const groupList = this.matchList[i].list
          for (let j = 0; j < groupList.length; j++) {
            const matchItem = groupList[j]
            if (matchItem.isChooseFlag && matchItem.competitorArr) {
              // 比赛被选中且竞赛者数组中没有元素时，不能创建，提示未选择竞赛者
              let isActChooce = false
              matchItem.competitorArr.forEach((channelItem) => {
                if (channelItem.act) {
                  isActChooce = true
                }
              })

              if (!isActChooce) {
                // 如果 isActChooce 没有为 true 则证明选中的比赛中有没有选中的竞赛者，所以为 false；因此验证不通过，跳出循环
                isCheckoutFlag = false
                break
              }
            }
          }
        }
        errorTipText = '分享的比赛中存在【未选择竞赛者】的比赛'
        console.debug('errorTipText:', chooseObj, isCheckoutFlag)
        if (isCheckoutFlag) {
          // 验证通过，直接组装缓存数据中的 actChannelArr 数据，创建的时候是从缓存中取数据的

          chooseObj.chooseIdArr.forEach((chooseId) => {
            let actChannelArr = []
            let scheduleCodes = []
            let channelTvs = []
            chooseObj.chooseItemArr.forEach((chooseItem) => {
              console.debug(
                'errorTipText:',
                chooseItem.chooseId === chooseId,
                chooseItem.competitorArr
              )
              if (
                chooseItem.chooseId === chooseId &&
                chooseItem.competitorArr &&
                chooseItem.competitorArr.length > 0
              ) {
                chooseItem.competitorArr.forEach((channelItem) => {
                  if (channelItem.act) {
                    if (channelItem.selectType === 'scheduleCode') {
                      scheduleCodes.push(channelItem.value)
                    }
                    if (channelItem.selectType === 'competitorCode') {
                      actChannelArr.push(channelItem.value)
                    }
                  }
                })
                chooseItem.actChannelArr = actChannelArr
                chooseItem.scheduleArr = scheduleCodes
              }
              if (
                chooseItem.chooseId === chooseId &&
                chooseItem.channelTvList &&
                chooseItem.channelTvList.length > 0
              ) {
                chooseItem.channelTvList.forEach((channelTV) => {
                  if (channelTV.act) {
                    channelTvs.push(channelTV.value)
                  }
                })
                chooseItem.channelTvs = channelTvs
              }
            })
          })
          this.$localStorage.setItem(
            multipleChoiceShareFixedBtn_modeType.localStorageName,
            JSON.stringify(chooseObj)
          )
        }
      }
      // console.debug('this.matchList:', this.matchList)
      console.debug(
        'errorTipText:',
        errorTipText,
        isCheckoutFlag,
        this.themeItem,
        chooseObj
      )
      return { isCheckoutFlag, errorTipText }
    },
    updateLocalStorageHandler(localStorageName, matchItem, actItem, type) {
      // 这个是 schedule_match_list 中选择频道功能与 multipleChoiceShare_fixedBtn 组件组合时单独自定义的函数；将每次被选中比赛中的频道修改及时同步到缓存中
      let chooseObj = this.$localStorage.getItem(localStorageName)
        ? JSON.parse(this.$localStorage.getItem(localStorageName))
        : {
            cid: this.currCid,
            // date: this.localStorageSaveDate,
            chooseItemArr: [],
            chooseIdArr: [],
          }
      if (chooseObj.cid === this.currCid) {
        if (chooseObj.chooseItemArr.length === 0) {
          // 因为只是点击频道选择，执行此函数证明，缓存中有数据，所以不会走到这里
          // this.matchList.forEach((matchItem) => {
          //   if (matchItem.isChooseFlag) {
          //     chooseObj.chooseItemArr.push(matchItem)
          //     chooseObj.chooseIdArr.push(matchItem.chooseId)
          //   }
          // })
        } else {
          // 这里是缓存中的数据，已经是被选中的比赛了，所以不用再判断是否被选中了
          if (type) {
            if (type === 'checkbox') {
              // 多选逻辑
              chooseObj.chooseItemArr.forEach((match) => {
                if (match.chooseId === matchItem.chooseId) {
                  match.competitorArr.forEach((channleItem) => {
                    if (channleItem.value === actItem.value) {
                      channleItem.act = !channleItem.act
                    }
                  })
                }
              })
            } else if (type === 'radio') {
              // 单选逻辑
              chooseObj.chooseItemArr.forEach((match) => {
                if (match.chooseId === matchItem.chooseId) {
                  match.competitorArr.forEach((channleItem) => {
                    if (channleItem.value === actItem.value) {
                      channleItem.act = true
                    } else {
                      channleItem.act = false
                    }
                  })
                  match.channelTvList.forEach((channleItem) => {
                    if (channleItem.value === actItem.value) {
                      channleItem.act = true
                    } else {
                      channleItem.act = false
                    }
                  })
                }
              })
            }
          }
        }
        this.$localStorage.setItem(localStorageName, JSON.stringify(chooseObj))
        this.localStorageChooseList = chooseObj.chooseItemArr
        console.debug('chooseObj:', chooseObj)
      } else {
        console.error('错误：赛事不同')
      }
    },
    clickMatchItemRadioItemEventHandler(data) {
      // cba单选， 亚运会可能单选可能多选
      // 这个是 schedule_match_list 中选择频道功能与 multipleChoiceShare_fixedBtn 组件组合时单独自定义的函数；将每次被选中比赛中的频道修改及时同步到缓存中
      let isUpdateLocalStroge = false
      let { matchItem, actItem, type } = data
      console.debug('clickMatchItemRadioItemEventHandler:', type)
      let matchList = JSON.parse(JSON.stringify(this.matchList))
      matchList.forEach((group) => {
        group.list.forEach((match) => {
          if (match.chooseId === matchItem.chooseId) {
            match.channelTvList.forEach((channleItem) => {
              if (channleItem.value === actItem.value) {
                channleItem.act = true
              } else {
                channleItem.act = false
              }
            })
            if (match.isChooseFlag) {
              isUpdateLocalStroge = true
            }
          }
        })
      })
      this.matchList = matchList
      if (isUpdateLocalStroge) {
        // 如果该比赛被选中，则需要将频道数据同步到缓存中，否则不需要同步缓存数据;
        // 由于缓存中可能会存储多天的比赛数据，所以不能再matchList中将被选中的数据替换到缓存中
        this.updateLocalStorageHandler(
          this.multipleChoiceShareFixedBtn_modeType.localStorageName,
          matchItem,
          actItem,
          type
        )
      }
    },
    clickMatchItemCheckboxItemEventHandler(data) {
      // cba单选， 亚运会可能单选可能多选
      // 这个是 schedule_match_list 中选择频道功能与 multipleChoiceShare_fixedBtn 组件组合时单独自定义的函数；将每次被选中比赛中的频道修改及时同步到缓存中
      let isUpdateLocalStroge = false
      let { matchItem, actItem, type } = data
      console.debug('clickMatchItemCheckboxItemEventHandler:', type)
      let matchList = JSON.parse(JSON.stringify(this.matchList))
      if (type === 'checkbox') {
        // 多选逻辑
        matchList.forEach((group) => {
          group.list.forEach((match) => {
            if (match.chooseId === matchItem.chooseId) {
              const actChannleItemIdArr = []
              match.competitorArr.forEach((channleItem) => {
                if (channleItem.act) {
                  actChannleItemIdArr.push(channleItem.value)
                }
              })
              if (!(actChannleItemIdArr.length === 1 && actItem.act)) {
                // 至少选中一个
                match.competitorArr.forEach((channleItem) => {
                  if (channleItem.value === actItem.value) {
                    channleItem.act = !channleItem.act
                  }
                })
                if (match.isChooseFlag) {
                  isUpdateLocalStroge = true
                }
              }
            }
          })
        })
      } else if (type === 'radio') {
        // 单选逻辑
        matchList.forEach((group) => {
          group.list.forEach((match) => {
            if (match.chooseId === matchItem.chooseId) {
              match.competitorArr.forEach((channleItem) => {
                if (channleItem.value === actItem.value) {
                  channleItem.act = true
                } else {
                  channleItem.act = false
                }
              })
              if (match.isChooseFlag) {
                isUpdateLocalStroge = true
              }
            }
          })
        })
      }
      this.matchList = matchList
      if (isUpdateLocalStroge) {
        // 如果该比赛被选中，则需要将频道数据同步到缓存中，否则不需要同步缓存数据;
        // 由于缓存中可能会存储多天的比赛数据，所以不能再matchList中将被选中的数据替换到缓存中
        this.updateLocalStorageHandler(
          this.multipleChoiceShareFixedBtn_modeType.localStorageName,
          matchItem,
          actItem,
          this.currScheduleMatchList_channelType
        )
      }
    },
    changeChooseNumEventHandler(data) {
      if (data.init) {
        // 清除缓存，重新开始
        this.$localStorage.removeItem(
          data.localStorageName // this.multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        this.matchList.forEach((group) => {
          group.list.forEach((item) => {
            item.isChooseFlag = false
          })
        })
      } else {
        const chooseSchedule = JSON.parse(
          this.$localStorage.getItem(
            data.localStorageName // this.multipleChoiceShareFixedBtn_modeType.localStorageName
          )
        )
        this.matchList.forEach((group) => {
          group.list.forEach((item) => {
            if (chooseSchedule.chooseIdArr.includes(item.chooseId)) {
              item.isChooseFlag = true
            } else {
              item.isChooseFlag = false
            }
            // 回显被选中的竞赛者
            chooseSchedule.chooseItemArr.forEach((chooseItem) => {
              if (chooseItem.chooseId === item.chooseId) {
                const localStoragePlayerIdArr = []
                const newPlayerIdArr = []
                chooseItem.competitorArr.forEach((playerItem) => {
                  localStoragePlayerIdArr.push(playerItem.value)
                })
                item.competitorArr.forEach((playerItem) => {
                  newPlayerIdArr.push(playerItem.value)
                })
                if (
                  JSON.stringify(localStoragePlayerIdArr) ===
                  JSON.stringify(newPlayerIdArr)
                ) {
                  // 数据一致，直接替换
                  item.competitorArr = chooseItem.competitorArr
                } else {
                  // 数据不一致，全部保持数据初始化状态
                }
              }
            })
          })
        })
        this.localStorageChooseList = chooseSchedule.chooseItemArr
      }
      this.smallBtnArr.forEach((item) => {
        if (item.type === 'check') {
          item.val = data.val
        }
      })
    },
    changeMatchLabelFixed(valPx, direction) {
      let scrollMatchItemHeightArr = this.scrollMatchItemHeightArr || []
      let curMatchLabelFixedIcon = null
      for (let i = 0; i < scrollMatchItemHeightArr.length; i++) {
        const item = scrollMatchItemHeightArr[i]
        if (item.heightPx > valPx && valPx <= item.heightPx) {
          if (item.heightPx - this.matchItemPbpx < valPx) {
            curMatchLabelFixedIcon = null
          } else {
            curMatchLabelFixedIcon = item.icon
          }
          break
        }
      }

      console.debug(
        'curMatchLabelFixed:',
        scrollMatchItemHeightArr,
        curMatchLabelFixedIcon,
        valPx,
        direction
      )
      if (this.matchTotal > 0) {
        this.curMatchLabelFixedIcon = curMatchLabelFixedIcon
      }
    },
    getScheduleMatchListDomHeigt() {
      let scrollMatchItemHeightArr = []
      let curHeightPx = 0
      const matchList = this.matchList
      matchList.forEach((item) => {
        let dom = document.getElementById(`matchList_${item.icon}`)
        curHeightPx += dom.offsetHeight //里面含paddingBottom值了
        scrollMatchItemHeightArr.push({
          icon: item.icon,
          heightPx: curHeightPx,
        })
      })
      this.curHeightPx = curHeightPx
      console.debug('getScheduleMatchListDomHeigt:', scrollMatchItemHeightArr)
      this.scrollMatchItemHeightArr = scrollMatchItemHeightArr
    },
    initPbPx() {
      this.matchItemPbpx = Math.ceil(2.78 * this.vw2px)
    },
    onResizeEvent() {
      this.initPbPx()
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        console.debug(
          'computedSelectOpt:',
          config.dataName,
          this[config.dataName],
          list,
          mix_id
        )
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          isFilterable: config.isFilterable ? config.isFilterable : false,
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'matchDate') {
            this.currStageMatchDate = valPathArr[1]
          } else if (valPathArr[0] === 'bigSports') {
            this.currStageBigSports = valPathArr[1]
          } else if (valPathArr[0] === 'delegation') {
            this.currStageDelegation = valPathArr[1]
          } else {
          }
          // 筛选表格逻辑
          this.initMatchListQuery()
          this.getScheduleMatchList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    // load() {
    //   console.debug('load')
    //   if (this.pnum > this.allPages || this.loading) {
    //     return
    //   }
    //   this.loading = true
    //   this.getScheduleMatchList()
    // },
    initMatchListQuery() {
      // this.pnum = 1
      this.matchTotal = 0
      this.allPages = 1
      if (this.matchList) {
        this.matchList = []
      }
      this.matchLabelArr = []
    },
    async getStageDateSports() {
      await https_select_dateBigSports(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        timeZone: this.curTimeZoneItem.val, // 'beijing',
      })
        .then((response) => {
          const res = response.data

          if (res.status === 0) {
            let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            // this.originDateBigSportsArr = res.data.map((item) => {
            //   return {
            //     value: item.date,
            //     name: item.dateFormatter,
            //     disciplines: item.disciplines,
            //     selected: item.selected,
            //   }
            // })
            const matchDateArr = res.data
              ? res.data.map((item, itemIndex) => {
                  if (item.selected) {
                    this.currStageMatchDate = item.date
                    this.selectOptData.configArr[0].selectIndex = itemIndex + 1
                    // let bigSportsArr = item.disciplines
                    //   ? item.disciplines.map((ceil) => {
                    //       return {
                    //         value: ceil.disciplineCode,
                    //         name: ceil.disciplineName,
                    //       }
                    //     })
                    //   : []
                    // if (bigSportsArr.length > 1) {
                    //   //   this.bigSportsArr = [].concat(selectAllObj, bigSportsArr)
                    //   this.bigSportsArr = [].concat([], bigSportsArr)
                    // } else {
                    //   this.bigSportsArr = bigSportsArr
                    // }
                    // this.currStageBigSports = this.bigSportsArr[0].value
                  }
                  return {
                    value: item.date,
                    name: item.dateFormatter,
                  }
                })
              : []
            this.matchDateArr = [].concat(
              JSON.parse(JSON.stringify(this.selectAllObj)),
              matchDateArr
            )
            console.debug('getStageDateSports:', this.bigSportsArr)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getBigSportsList() {
      await https_sportsList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
              let bigSportsArr = res.data
                ? res.data.map((ceil) => {
                    return {
                      value: ceil.disciplineCode,
                      name: ceil.disciplineName,
                    }
                  })
                : []
              let actIndex = 0
              this.bigSportsArr = [].concat(selectAllObj, bigSportsArr)
              this.currStageBigSports = this.bigSportsArr[actIndex].value
            } else {
              this.bigSportsApiList = []
              this.currStageBigSports = ''
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getDelegationList() {
      let params = {
        sid: this.currSid,
      }
      await https_select_delegationList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          // 这里代表团不需要增加【全部】，因为此页面比赛列表不带分页，单日全部项目全部代表团比赛太多，夏季奥运会至少几百场
          if (res.status === 0) {
            let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            this.delegationArr = res.data
              ? [].concat(
                  selectAllObj,
                  res.data.map((item) => {
                    return {
                      value: item.organisationCode,
                      name: item.organisationName,
                    }
                  })
                )
              : []
            let actIndex = 0
            if (this.currCid !== 'NSG' && this.delegationArr.length > 1) {
              // 默认取第一个代表团
              actIndex = 1
            }
            this.currStageDelegation = this.delegationArr[actIndex].value
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    computedMatchList(list) {
      console.debug('computedMatchList:', list)
      let matchLabelArr = []
      if (list && list.length > 0) {
        let matchList = this.matchList ? this.matchList : []
        let labelObj = {}
        list.forEach((item) => {
          let curIndex = 0
          let newItem = {}
          newItem.matchTime = item.formatTime
          newItem.matchName = `${item.disciplineName}·${item.eventName}${item.phaseName}`
          newItem.isChina = item.cn
          newItem.phaseCode = item.phaseCode
          newItem.chooseId = item.phaseCode
          // let isDefaultActCompetitorsIndex = 0
          // if (item.competitors && item.competitors.length > 1) {
          //   // 如果只有1个，则默认选中第一个；如果大于1个，则默认什么都不选
          //   isDefaultActCompetitorsIndex = item.competitors.length
          // }
          // newItem.competitorArr = item.competitors.map(
          //   (competitorItem, competitorIndex) => {
          //     let competitorName = ''
          //     if (
          //       competitorItem.athletes &&
          //       competitorItem.athletes.length > 0 &&
          //       competitorItem.athletes.length < 5
          //     ) {
          //       const athletesArr = []
          //       competitorItem.athletes.forEach((playerItem) => {
          //         athletesArr.push(playerItem.playerName)
          //       })
          //       competitorName = athletesArr.join('/')
          //     } else {
          //       competitorName = competitorItem.organisationName
          //     }
          //     return {
          //       value: competitorItem.competitorCode,
          //       competitorName,
          //       act: false, //最新逻辑默认全部不选中， 之前旧逻辑 competitorIndex === isDefaultActCompetitorsIndex,
          //       rankNum: competitorItem.rankNum,
          //       resultValue: competitorItem.resultValue,
          //     }
          //   }
          // )

          /**
           * electType：scheduleCode，一般competitorCodes里会有两个对象，第一个是主队第二个是客队，
           * 应当展示一条，athletes的个数大于2显示运动员名称，其余显示organisationName，
           * 结构如下图，应显示：美国 6 : 5 ROC
           */
          newItem.competitorArr = item.selectCompetitors.map(
            (selectCompetitor) => {
              const competitors = selectCompetitor.competitors
              let showContent = ''
              if (selectCompetitor.selectType === 'scheduleCode') {
                const mainCompetitor = competitors[0]
                const guestCompetitor = competitors[1]
                let mainName = ''
                let guestName = ''
                if (
                  mainCompetitor &&
                  mainCompetitor.athletes &&
                  mainCompetitor.athletes.length > 0 &&
                  mainCompetitor.athletes.length < 5
                ) {
                  mainName = `${mainCompetitor.athletes
                    .map((item) => item.playerName)
                    .join('/')}`
                } else {
                  mainName = mainCompetitor.organisationName
                }
                if (
                  guestCompetitor &&
                  guestCompetitor.athletes &&
                  guestCompetitor.athletes.length > 0 &&
                  guestCompetitor.athletes.length < 5
                ) {
                  guestName = `${guestCompetitor.athletes
                    .map((item) => item.playerName)
                    .join('/')}`
                } else {
                  guestName = guestCompetitor?.organisationName
                }
                if (mainCompetitor.resultValue && guestCompetitor.resultValue) {
                  showContent = `${mainName} ${mainCompetitor.resultValue}-${guestCompetitor.resultValue} ${guestName}`
                } else {
                  showContent = `${mainName} VS ${guestName}`
                }
              } else if (selectCompetitor.selectType === 'competitorCode') {
                const competitor = competitors[0]
                let name = ''
                if (
                  competitor &&
                  competitor.athletes &&
                  competitor.athletes.length > 0 &&
                  competitor.athletes.length < 5
                ) {
                  name = `${competitor.athletes
                    .map((item) => item.playerName)
                    .join('/')}`
                } else {
                  name = competitor.organisationName
                }
                showContent = `${name}( 排名：${competitor.rankNum} 成绩：${competitor.resultValue} )`
              }

              return {
                selectType: selectCompetitor.selectType,
                value: selectCompetitor.selectCode,
                showContent,
                act: false, //最新逻辑默认全部不选中， 之前旧逻辑 competitorIndex === isDefaultActCompetitorsIndex,
              }
            }
          )
          if (this.themeItem && this.themeItem.inFilter) {
            const channelTvList = JSON.parse(
              JSON.stringify(this.themeItem.inFilter.filterTypes[0].values)
            )
            channelTvList.forEach((item, itemIndex) => {
              if (itemIndex === 0) {
                item.act = true
              } else {
                item.act = false
              }
              item.value = item.value + ''
            })
            newItem.channelTvList = channelTvList
          }
          newItem.sportsId = item.disciplineCode
          newItem.sportsName = item.disciplineName
          newItem.eventId = item.eventCode
          newItem.eventName = item.eventName
          newItem.formatTime = item.formatTime
          newItem.delegationName = item.organisationName
          newItem.delegationId = item.organisationCode
          newItem.isChooseFlag = false
          newItem.formatDate = item.formatDate
          newItem.bjStartDate = item.bjStartDate
          newItem.startDate = item.startDate

          // if (matchLabelArr && matchLabelArr.length === 0) {
          //   matchLabelArr.push(item.disciplineCode)
          //   labelObj = {
          //     label: item.disciplineName,
          //     icon: item.disciplineCode,
          //     list: [],
          //   }
          // }
          // labelObj.list.push(newItem)

          if (matchLabelArr && matchLabelArr.length > 0) {
            curIndex = matchLabelArr.indexOf(item.disciplineCode)
          } else {
            matchLabelArr.push(item.disciplineCode)
            labelObj = {
              label: item.disciplineName,
              icon: item.disciplineCode,
              list: [],
            }
          }
          if (curIndex > -1) {
            if (!labelObj.icon || labelObj.icon !== item.disciplineCode) {
              labelObj = matchList[curIndex]
                ? matchList[curIndex]
                : {
                    label: item.disciplineName,
                    icon: item.disciplineCode,
                    list: [],
                  }
            }
          } else {
            matchLabelArr.push(item.disciplineCode)
            console.debug(
              'labelObj:',
              matchList.length,
              labelObj,
              item.disciplineCode
            )
            //结束上一个区域
            if (
              matchList.length > 0 &&
              matchList[matchList.length - 1].icon === labelObj.icon
            ) {
              // 新加载的数据第一批中有上一个组数据，此时是替换
              matchList[matchList.length - 1] = labelObj
            } else {
              // 这层if是为了判断一种情况，比如2页加载完后，第三页是一组新的大项数据，此时逻辑会走到这里，所以需要判断这个labelObj里面的list是否有元素，如果有则push，如果没有则不push一个空的大项标题
              if (labelObj && labelObj.list && labelObj.list.length > 0) {
                // 数组中并没有该区域数据，直接push
                matchList.push(labelObj)
              }
            }
            labelObj = {
              label: item.disciplineName,
              icon: item.disciplineCode,
              list: [],
            }
            console.debug(
              'labelObj end:',
              matchList.length,
              matchList[matchList.length - 1].icon,
              labelObj
            )
          }
          labelObj.list.push(newItem)
        })

        if (labelObj.list.length > 0) {
          let curIndex = matchLabelArr.indexOf(labelObj.icon)
          if (curIndex > -1) {
            // console.debug('labelObj end:', matchList, matchList[curIndex])
            if (
              matchList.length > 0 &&
              matchList[matchList.length - 1].icon === labelObj.icon
            ) {
              // 新加载的数据第一批中有上一个组数据，此时是替换
              matchList[matchList.length - 1] = labelObj
            } else {
              // 数组中并没有该区域数据，直接push
              matchList.push(labelObj)
            }
          } else {
            matchList.push(labelObj)
          }
        }
        this.matchList = JSON.parse(JSON.stringify(matchList))
        this.matchLabelArr = JSON.parse(JSON.stringify(matchLabelArr))
        console.debug(
          'computedMatchList end:',
          labelObj,
          matchList,
          matchLabelArr
        )

        this.isClearlearLocalStorageChoose()
      }
    },
    async getScheduleMatchList() {
      let params = {
        cid: this.currCid,
        sid: this.currSid,
        date: this.currStageMatchDate
          ? this.currStageMatchDate === 'all'
            ? ''
            : this.currStageMatchDate
          : '',
        sportsId: this.currStageBigSports
          ? this.currStageBigSports === 'all'
            ? ''
            : this.currStageBigSports
          : '',
        delegationId: this.currStageDelegation
          ? this.currStageDelegation === 'all'
            ? ''
            : this.currStageDelegation
          : '',
        timeZone: this.curTimeZoneItem.val,
      }
      console.debug(params)
      await https_playersSchedule_matchList(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data && res.data.dataList && res.data.dataList.length > 0) {
              this.matchTotal = res.data.dataList.length
              this.allPages = 1
              if (this.scrollAreaDom) {
                this.scrollAreaDom.scrollTo(0, 0)
              }
              this.matchList = []
              this.matchLabelArr = []
              this.curMatchLabelFixedIcon = null
              this.initScroll()
              this.computedMatchList(res.data.dataList)
              this.$nextTick(() => {
                this.getScheduleMatchListDomHeigt()
              })
            } else {
              console.debug('暂无数据')
              this.matchTotal = 0
              this.matchList = []
            }
            console.debug('暂无数据:', this.matchTotal, this.matchList)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_schedule {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    &.multipleChoiceShare_fixedBtn_isCircular {
    }
    .tableScrollArea {
      position: relative;
      .match_label_fixed {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 3.472vw;
        background-color: var(--mixtmt_whiteColor);
        .match_label {
          width: 100%;
          height: 3.472vw;
          background-image: var(--mixtmt_scheduleMatchList_dateBg);
          background-size: 100% auto;
          background-position: left top;
          background-repeat: no-repeat;

          .label_textArea {
            position: absolute;
            left: 0;
            top: 50%;
            z-index: 2;
            transform: translateY(-50%);
            width: 21.55%;
            font-size: 1.38vw;
            color: var(--mixtmt_whiteColor);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            .labelIcon {
              width: 2.778vw;
              height: 2.778vw;
              border: 1.5px solid var(--mixtmt_whiteColor);
              border-radius: 50%;
              overflow: hidden;
              margin-right: 0.694vw;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            & .letterSpa {
              letter-spacing: 0.4vw;
            }
          }
        }
      }
      /* .scrollDomContain {
          max-height: calc(100vh - 19.142vw);
          overflow: auto;
        } */
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
